module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tara Taylor Quinn\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" Tara Taylor Quinn, is a "), _c('I', [_vm._v("USA Today")]), _vm._v("–bestselling author of one hundred novels, which have been translated into twenty languages and has sold more than seven million copies. Known for her intense emotional fiction, Quinn’s novels have received critical acclaim, including the 2008 National Reader’s Choice Award, and five RITA Award finalist, and a former president and board director of the Romance Writers of America. She has appeared often on local and national TV, including "), _c('I', [_vm._v("CBS Sunday Morning")]), _vm._v(". For additional offers, news, and contests, visit the author at tarataylorquinn.com. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1ChrJF8/tc-custom/9781426874383.jpg?1728259255657",
      "alt": "This image is the cover for the book 3rd Secret, The Chapman Files"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("3rd Secret, The Chapman Files\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Rick Thomas stole drug-cartel evidence from a government facility. And spent three years in a federal prison."), _c('br'), _c('br'), _vm._v("Attorney Erin Morgan has a rule: never defend the bad guys. But Rick Thomas, quiet and self-assured, doesn't "), _c('i', [_vm._v("seem")]), _vm._v(" bad. That's why she agrees to defend him against what he swears is a trumped-up murder charge. She's ignoring her experience and listening to her instincts instead."), _c('br'), _c('br'), _vm._v("But psychologist and expert witness Kelly Chapman is listening to "), _c('i', [_vm._v("her")]), _vm._v(" instincts, too. And they're saying that Rick Thomas is lying to Erin. That he's keeping secrets. That he's a dangerous man. And that, despite everything, maybe he's one of the "), _c('i', [_vm._v("good")]), _vm._v(" guys."), _c('br'), _c('br')]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0